<template>
  <div class="hero dark">
    <div class="container container-small">
      <header>
        <TextSection class="header"
          :header="header"
          :description="description"
          :cutLength='1000'
          :cutLengthTextBig="400"
          :noIndentation="true"/>
      </header>
      <TextSlider :items="items" class="text-m"/>
      <ScrollToNext v-if="!isPhone"/>
    </div>
    <div class="background-wrapper dark">
      <video class="background-video"
        src="@/assets/video/mk-video.mp4"
        poster="@/assets/video/mk-video-poster.jpg"
        preload="none"
        autoplay
        playsinline
        loop="true"
        defaultMuted
        muted >
      </video>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TextSection from '@/components/TextSection.vue'
import TextSlider from '@/components/TextSlider.vue'
import ScrollToNext from '@/components/ScrollToNext.vue'

export default {
  name: 'heroSlider',
  props: ['items', 'header', 'description'],
  components: {
    TextSection,
    TextSlider,
    ScrollToNext
  },
  computed: {
    ...mapGetters([
      'breakpoint'
    ]),
    isPhone () {
      return this.breakpoint === 'mobile'
    }
  }
}
</script>

<style scoped lang="scss">
  .container {
    position: relative;
    min-height: 100%;
    padding-top: 77px;
    @include mobile {
      height: calc(100vh - 16px);
    }
    /deep/ .slider {
      @include mobile {
        background: $body-bg;
        bottom: 0;
        color: $text-dark;
        margin-top: 80px;
        position: relative;
        z-index: 1000000;
        .hight-contrast & {
          background: $contrast-bg;
        }
        // .font-size-l & {
        //   bottom: -130px;
        // }
        .controllers {
          top: -60px;

          .not-on-dark {
            .dark & {
              display: block;
            }
          }
          .on-dark {
            display: block;
            .dark & {
              display: none;
            }
          }
        } // END .controllers;
      }
    }
    .header-options {
      position: absolute;
      top: calc(100vh - 190px);
      left: 0;
      z-index: 9999;
    }
  }
  .hero {
    height: calc(100vh - 84px);
    overflow: hidden;
    position: static;
    @include mobile {
      min-height: 100vh;
      margin-bottom: 280px;
      overflow: visible;
      position: relative;
      .font-size-l & {
        margin-bottom: 320px;
      }
    }
    .container {
      @include mobile-small {
        /deep/ .multi {
          .parts-wrapper {
            min-height: 170px;
          }
        }
      }
    }
    header {
      display: block;
      position: absolute;
      top: 10%;
      left: 0;
      max-width: 380px;
      width: 100%;
      z-index: 999999;
      text-align: left;
      @include mobile {
        height: 100%;
        position: relative;
        top: 0;
      }
      // background-color: rgba($color: #fff, $alpha: .2)
    }
    .background-wrapper {
      background: $bg-dark url('../assets/video/mk-video-poster.jpg') no-repeat 0 0;
      background-size: cover;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      overflow: hidden;
      z-index: -1;
      &.dark {
        background-color: $bg-dark;
        color: $text-light;
      }
      @include mobile {
        top: -78px;
        min-height: 100vh;
        height: calc(100% + 78px);
      }
    }
    .background-video {
      display: block;
      transform: translate(-50%, -50%);
      position: absolute;
      min-width: 100%;
      min-height: 100%;
      width: auto;
      height: auto;
      top: 50%;
      left: 50%;
      @include mobile {
        // height: 100%;
      }
    }
  }
</style>
